import "core-js/modules/web.dom-collections.iterator.js";
import { useEffect, useState } from "react";
import { observer } from "mobx-react";
import CommonStrata from "../../Models/Definition/CommonStrata";
import Styles from "./parameter-editors.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const NumberParameterEditor = _ref => {
  let {
    parameter
  } = _ref;
  const [value, setValue] = useState(0);
  useEffect(() => {
    if (parameter.defaultValue !== undefined) {
      setValue(parameter.defaultValue);
    }
  }, [parameter.defaultValue]);
  const onChange = e => {
    setValue(parseFloat(e.target.value));
    parameter.setValue(CommonStrata.user, parseFloat(e.target.value));
  };
  const min = parameter.minimum || "";
  const max = parameter.maximum || "";
  return /*#__PURE__*/_jsx("input", {
    className: Styles.field,
    type: "number",
    onChange: onChange,
    value: value,
    min: min,
    max: max
  });
};
export default observer(NumberParameterEditor);